import createScrollOpt from "@/assets/js/vuescrollOption";
import { orgChange, addEnroll } from "@/api/system_manager/api";
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value !== "") {
        callback();
      } else {
        callback(new Error("请输入电话"));
      }
    };

    const validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback();
        return;
      }
      if (email(value)) {
        callback();
      } else {
        callback(new Error("请输入格式正确的邮箱"));
      }
    };
    return {
      ifContactDiaShow: false,
      testContact: false,
      disScrollOpt: createScrollOpt(true),
      contactData: {
        contactInfoList: [{ name: "", mobile_phone: "", email: "", work: "", id: 1 }],
      }, // 联系人列表
      validatePhone,
      validateEmail,
    }
  },

  created() {
    if(!this.isEdit) this.getClassLinks();
  },

  methods: {
    // 联系人弹窗信息
    contactDiaOpen() {
      this.$nextTick(() => {
        this.$refs["contactDialogForm"].clearValidate();
      });
      const transfer_item_linkman = JSON.parse(
        JSON.stringify(this.formData.transfer_item_linkman)
      );
      this.$set(this.contactData, "contactInfoList", transfer_item_linkman);
    },
    // 删除联系人
    delContact(index) {
      this.contactData.contactInfoList.splice(index, 1);
    },
    // 添加联系人
    addContact() {
      this.contactData.contactInfoList.push({
        name: "",
        mobile_phone: "",
        email: "",
        work: "",
        id: this.contactData.contactInfoList.length + 1,
      });
    },
    // 保存联系人弹窗
    saveContactList() {
      this.$refs["contactDialogForm"].validate((valid) => {
        const contactData = JSON.parse(JSON.stringify(this.contactData));
        if (valid) {
          this.$set(
            this.formData,
            "transfer_item_linkman",
            contactData.contactInfoList
          );
          this.ifContactDiaShow = false;
          this.testContact = true;
        }
      });
    },

    //  获取默认联系人
    getClassLinks() {
      console.log('#######', '')
      orgChange({})
        .then(({ data: { status, result: { linkmen } } }) => {
          if (status === 0) {
            console.log('linkmen', linkmen)
            if (linkmen.length > 0) {
              this.contactData.contactInfoList = linkmen.map(
                ({ email, mobile_phone, name, work, tc_id }, i) => ({
                  name,
                  email,
                  work,
                  mobile_phone,
                  id: i + 1
                })
              );
              this.testContact = true;
            } else {
              this.testContact = false;
            }
            this.formData.transfer_item_linkman = JSON.parse(
              JSON.stringify(this.contactData.contactInfoList)
            );
            // 有了默认联系人的话，将联系人的校验结果为true，反之为false
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

  },
}